import { Container, Header } from "components/Page"

import Breadcrumbs from "components/Breadcrumbs"
import ListCompanies from "./List"
import { Surface } from "components/Surface"
import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"

type Props = {
  entity: "market" | "agency"
}

function Companies({ entity = "market" }: Props) {
  const { t } = useI18n()

  return (
    <Container>
      <Breadcrumbs section={t("nav.admin")} current={t("nav.admin.company")} />
      <Header label={t("nav.admin.company")} />
      <Surface className={styles.surface}>
        <ListCompanies entity={entity} />
      </Surface>
    </Container>
  )
}

const styles = {
  surface: css`
    padding: var(--spacing-xxl-2) var(--spacing-m) var(--spacing-m);
  `,
}

export default Companies
